module.exports = __webpack_public_path__ + "img/video.68984f94.png";